import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { QRCodeCanvas } from "qrcode.react";
import { downloadFile } from "../../../shared/utils/fileUtils";
import { Machine } from "../models/models";
import useTranslation from "../../../shared/hooks/useTranslation";

export interface MachineQRCodeDialogProps {
  open: boolean;
  machine: Machine;
  onClose?: () => void;
}

const MachineQRCodeDialog = ({ open, machine, onClose }: MachineQRCodeDialogProps) => {
  const machineUrl = `${window.location.origin}/public/machines/${machine.internalNumber}`;
  const { translate } = useTranslation(["myMachinery", "common"]);

  const handleDownload = () => {
    downloadQRCode();
  };

  const downloadQRCode = () => {
    const qrCanvas = document.getElementById("qr-code") as HTMLCanvasElement;
    const qrCodeUrl = qrCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

    downloadFile(qrCodeUrl, `machine-${machine.internalNumber}-qr-code.png`);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box component="p" className="heading-2">{translate("qrCode")}</Box>
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 14,
          top: 14,
          color: "#333333"
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <QRCodeCanvas id="qr-code" value={machineUrl} size={280} />
      </DialogContent>

      <DialogActions className="flex mt-2">
        <Button variant="text" className="w-full" onClick={onClose}>
          {translate("common:buttons.close")}
        </Button>

        <Button variant="contained" className="w-full" onClick={handleDownload}>
          {translate("common:buttons.download")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MachineQRCodeDialog;